import React, { useState, useContext } from "react";
import { StoreContext } from "../../Context/StoreContext";
import RoomCard from "../../VibehutUI/Card/RoomCard";
import { videoAppUrl } from "../../utils/axios";
import { Link } from "react-router-dom";
import Carousel from "react-multi-carousel";
import { carouselResponsiveConfig } from "../../utils/utils";
import { useWindowSize } from "../../hooks/useWindowSize";
import { singleClaimedRoomRoutes, singleRoomRoutes } from "../../routes";
import { openEventSubscriptionModal } from "../../actions/eventModalActions";
import { checkRoomHasLiveEventAndUserAccess } from "../../services/rooomService";
import useIsPWA from "../../hooks/usePWA";
import { showLoginModal } from "../../actions/uiModalActions";

function MyRecentRooms() {
  const { state, dispatch } = useContext(StoreContext);
  const [isFetching, setIsFetching] = useState(false);
  const [activeCard, setActiveCard] = useState(0);
  const { width } = useWindowSize();
  const isPWA = useIsPWA();
  const {
    auth: { user },
    room: { recentRooms },
  } = state;

  const goToCallPage = (roomId) => {
    if (!isPWA) {
      window.open(`${videoAppUrl}/call?roomKey=${roomId}`);
    } else {
      window.location.href = `${videoAppUrl}/call?roomKey=${roomId}`;
    }
  };

  const checkAccessAndRedirect = async (roomId) => {
    setIsFetching(true);
    const checkRoomAccess = await checkRoomHasLiveEventAndUserAccess(
      roomId,
      user.token,
    );
    if (checkRoomAccess.data.isUserAllowed) {
      setIsFetching(false);
      goToCallPage(roomId);
    } else {
      setIsFetching(false);
      openEventSubscriptionModal(
        dispatch,
        checkRoomAccess.data.event,
        `There is a live event going on in this room. Please subscribe to join the event. Otherwise you can wait join the room after the event ends.`,
        "event",
      );
    }
  };

  const startCall = async (room, index) => {
    if (user) {
      if (room) {
        if (room.isNftCollectionRoom) {
          if (room.isAccessible) {
            goToCallPage(room._id);
          }
        } else {
          setActiveCard(index);
          checkAccessAndRedirect(room._id);
        }
      }
    } else {
      showLoginModal(dispatch);
    }
  };

  return (
    <>
      {recentRooms.length > 0 && (
        <div className="relative my-recent-rooms">
          <div className="pt-8">
            <p className="font-bold md:text-2xl text-xl text-darkNight dark:text-frescoWhite px-2">
              My Recent Rooms
            </p>
            <div className="hidden md:grid w-full  md:grid-cols-3 lg:grid-cols-3 3xl:grid-cols-4 grid-cols-1  gap-6 py-6 px-2">
              {recentRooms
                .slice(0, width >= 1600 ? 4 : 3)
                .map((room, index) => {
                  const path = room?.slug
                    ? singleClaimedRoomRoutes.path.replace(":slug", room.slug)
                    : singleRoomRoutes.path.replace(":roomId", room._id);
                  return (
                    <div key={room._id}>
                      <Link className="cursor-pointer" key={room._id} to={path}>
                        <RoomCard
                          room={room}
                          recentRooms
                          showRoomInfo={false}
                        />
                      </Link>
                      <button
                        className="w-full join-call mt-3 cusBtn cusBtn-vibhut-primary cusBtn-vibhut-sm bg-purple-200 "
                        onClick={() => startCall(room, index)}
                        disabled={isFetching && index === activeCard}
                      >
                        {isFetching && index === activeCard
                          ? "Joining..."
                          : "Join Call"}
                      </button>
                    </div>
                  );
                })}
            </div>
            <div className="md:hidden block py-6">
              <Carousel
                responsive={carouselResponsiveConfig}
                renderButtonGroupOutside={true}
                itemClass="px-2.5"
                arrows={false}
                shouldResetAutoplay={false}
              >
                {recentRooms.map((room, index) => {
                  const path = room?.slug
                    ? singleClaimedRoomRoutes.path.replace(":slug", room.slug)
                    : singleRoomRoutes.path.replace(":roomId", room._id);
                  return (
                    <div key={index}>
                      <Link className="cursor-pointer" key={room._id} to={path}>
                        <RoomCard
                          room={room}
                          recentRooms
                          showRoomInfo={false}
                        />
                      </Link>
                      <button
                        className="w-full join-call mt-3 cusBtn cusBtn-vibhut-primary cusBtn-vibhut-sm bg-purple-200 "
                        onClick={() => startCall(room, index)}
                        disabled={isFetching && index === activeCard}
                      >
                        {isFetching && index === activeCard
                          ? "Joining..."
                          : "Join Call"}
                      </button>
                    </div>
                  );
                })}
              </Carousel>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default MyRecentRooms;
